export default __webpack_public_path__ + "static/media/SourceSerifPro-BlackItalic.755bd5ae.ttf";